import { render } from "./Folders.vue?vue&type=template&id=9d7b38a6&ts=true"
import script from "./Folders.vue?vue&type=script&lang=ts"
export * from "./Folders.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__